import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { format } from 'date-fns';
import { HeaderProgressTracker } from '../Common/HeaderStepper/HeaderProgressTracker';
import FullDigital from './FullDigital';
import Haven from '../Common/InsuranceRequest/Haven';
import Bestow from '../Common/InsuranceRequest/Bestow';
import Lga from '../Common/InsuranceRequest/Lga';
import TobaccoUsage from '../Common/Helpers/TobaccoUsage';
import { saveSessionEvent } from '../../../session';
import { getBasicInfo, getSessionStorageItem, SESSION_STORAGE_BASIC_INFO_KEY, SESSION_STORAGE_FULLY_DIGITAL_OBJECT_KEY, SESSION_STORAGE_ACCOUNT_KEY, setSessionStorageItem, SESSION_STORAGE_UTM_DATA } from '../../../sessionStorage';
import { QuoteProductID } from '../Common/QuoteProductID';
import { GetHandoffPath } from '../Common/GetHandoffPath';
import PropTypes from 'prop-types';
import GetProductDetail from '../../Common/GetProductDetail';

export default function Digital(props) {

    useEffect(() => { saveSessionEvent(); }, [props.location]);

    const path = props.location ? props.location.pathname.split("/").pop() : null;
    const allFormState = getSessionStorageItem(SESSION_STORAGE_FULLY_DIGITAL_OBJECT_KEY);
    const basicInfo = getBasicInfo();
    const prefill = props.location.search && props.location.search.toLowerCase().includes('prefill');

    const newFormState = {
        currentStep: 1,
        pages: {
            quoter: FullDigital.DefaultFormState(prefill),
        },
    };

    const initialFormState = allFormState || newFormState;

    const [formState, setFormState] = useState(initialFormState);

    useEffect(() => {
        let productDetail = GetProductDetail(['/landing/digital-term', '/landing/term/digital-term']);
        if (productDetail === undefined) {
          productDetail = GetProductDetail(['/landing/term-insurance', '/term-insurance']);
          const redirectPath = productDetail === undefined ? '/' : '/landing/term-insurance';
          props.history.push(redirectPath);
        }
      }, []);    

    useEffect(() => {

        if (!path) {
            return;
        }

        let nextStep = steps.find((s) => s.path === path);

        if (!nextStep) {
            const newPath = props.location ? props.location.pathname.split("/").slice(-2) : null;
            if (!newPath) {
                return;
            }

            nextStep = steps.find((s) => s.path === newPath[0]);
            if (!nextStep) {
                return;
            }
        }
        const newFormState = { ...formState, currentStep: nextStep.step };
        setFormState(newFormState);
    }, [path]);

    const onNext = () => {
        let nextStep = steps.find((s) => s.step === formState.currentStep + 1);

        if (nextStep.path === "bestow" && (formState.pages.quoter.product === "HavenTerm" || formState.pages.quoter.selectedQuote.productID === QuoteProductID.HAVEN_SI_PRODUCT_ID)) {
            nextStep = steps.find(s => s.step === nextStep.step + 1);
        }

        if (nextStep.path === "bestow" && formState.pages.quoter.product === "OPTerm") {
            nextStep = steps.find(s => s.step === nextStep.step + 2);
        }

        if (!nextStep) {
            throw new Error('onNext did not find a next step');
        }

        const newFormState = { ...formState, currentStep: nextStep.step };

        setFormState(newFormState);
        setSessionStorageItem(SESSION_STORAGE_FULLY_DIGITAL_OBJECT_KEY, newFormState);

        props.history.push(`/quote/term-life-insurance/fully-digital/${nextStep.path}`);
        window.scroll(0, 0);
    };

    const onBack = () => {
        let backStep = steps.find(s => s.step === formState.currentStep - 1);

        if (backStep.path === "bestow" && formState.pages.quoter.product === "HavenTerm") {
            backStep = steps.find(s => s.step === backStep.step - 1);
        }

        if (backStep) {
            const newFormState = { ...formState, currentStep: backStep.step };

            setFormState(newFormState);
            setSessionStorageItem(SESSION_STORAGE_FULLY_DIGITAL_OBJECT_KEY, newFormState);

            props.history.push(`/quote/term-life-insurance/fully-digital/${backStep.path}`);
            window.scroll(0, 0);

        }
        else {
            props.history.push('/');
        }
    };

    const logFinalDigitalQuote = (email, firstName, lastName, quoter, oneClickTypeId, referralId = null, phone = '') => {
        const account = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
        const isHavenLifeProduct = quoter.selectedQuote.productID === QuoteProductID.HAVEN_SI_PRODUCT_ID || quoter.selectedQuote.productID === QuoteProductID.HAVEN_TERM_PRODUCT_ID;
        const utmData = getSessionStorageItem(SESSION_STORAGE_UTM_DATA);

        let digitalQuoteData = {
            CoverageAmount: quoter.coverageAmount,
            CoverageLength: quoter.term,
            State: basicInfo.state,
            BirthDate: format(new Date(basicInfo.birthdate), 'yyyy-MM-dd'),
            HealthClass: quoter.healthClass,
            Gender: basicInfo.gender,
            Tobacco: TobaccoUsage(basicInfo.tobacco),
            Email: email,
            FirstName: firstName,
            LastName: lastName,
        };
        if (isHavenLifeProduct){
            digitalQuoteData = { ...digitalQuoteData, Phone:phone };
        }
        return new Promise(resolve => {
            //save quote log for bms
            //keep in mind that this needs to match 1click quote log format
            const requestString = JSON.stringify(digitalQuoteData);

            let jsonResponse;

            // set custom quote id in response if present 
            if (referralId) {
                const response = { ...quoter.selectedQuote };
                response.PartnerQuoteId = referralId;
                response.UTMs = utmData || "";
                jsonResponse = JSON.stringify(response);
            }
            else {
                quoter.selectedQuote.UTMs = utmData || "";
                jsonResponse = JSON.stringify(quoter.selectedQuote);
            }

            const pathName = GetHandoffPath(quoter.selectedQuote.productID);
            saveSessionEvent(true, pathName);
            //clear product session
            sessionStorage.removeItem(SESSION_STORAGE_FULLY_DIGITAL_OBJECT_KEY);
            sessionStorage.removeItem(SESSION_STORAGE_BASIC_INFO_KEY);

            fetch(`/api/QuoteLog/ArchiveQuoteLog`, {
                method: 'post',
                headers: {
                'Content-Type': 'application/json',
                'SessionId': account.sessionId
                },
                body: JSON.stringify({
                    QuoteLogId: quoter.selectedQuote.quoteLogId,
                    OneClickTypeID: oneClickTypeId, //digital oneclick type
                    Request: requestString,
                    Response: jsonResponse,
                    ApplicationID: account.sessionId,
                    OneClickAccountID: account.account.oneClickAccountId,
                    SessionID: account.sessionId,
                    ConsumerAccountId: account.account.accountId,
                    PartnerQuoteId: referralId,
                }),
            }).then(() => { resolve(); });
        });
        
      };

    const steps = [
        {
            step: 1,
            path: 'fully-digital',
            progressTitle: 'Getting Started',
            component: <FullDigital
                formState={formState.pages.quoter}
                fullFormState={formState}
                onMultiFieldChange={(fs) => {
                    setFormState(fs);
                }}
                onNext={onNext}
                onBack={onBack}
                history={props.history}
            />,
            hideProgressTracker: true,
            showContainer: false,
        },
        {
            step: 2,
            path: 'bestow',
            title: 'Your Life Insurance Request',
            progressTitle: 'Getting Started',
            component: <Bestow
                formData={formState.pages}
                onBack={() => {props.history.push(`/quote/term-life-insurance/fully-digital`);}}
                history={props.history}
                basicInfo={basicInfo}
                logQuote={logFinalDigitalQuote}
            />,
            hideProgressTracker: true,
            hidden: false,
        },
        {
            step: 3,
            path: 'haven',
            title: 'Your Life Insurance Request',
            progressTitle: 'Getting Started',
            component: <Haven
                formData={formState.pages}
                onBack={() => {props.history.push(`/quote/term-life-insurance/fully-digital`);}}
                basicInfo={basicInfo}
                logQuote={logFinalDigitalQuote}
            />,
            hideProgressTracker: true,
            hidden: false,
        },
        {
            step: 4,
            path: 'lga',
            title: 'Your Life Insurance Request',
            progressTitle: 'Getting Started',
            component: <Lga
                formData={formState.pages}
                onBack={() => {props.history.push(`/quote/term-life-insurance/fully-digital`);}}
                history={props.history}
                basicInfo={basicInfo}
                logQuote={logFinalDigitalQuote}
            />,
            hideProgressTracker: true,
            hidden: false,
        },
    ];

    const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];

    return (
        <div>
            <Helmet>
                <title>Term life insurance - {currentStepObj.progressTitle} </title>
            </Helmet>

            {currentStepObj && currentStepObj.step === 1 &&
                <div className="Digital">
                    {currentStepObj.component}
                </div>
            }
            {currentStepObj && currentStepObj.step !== 1 &&
                <HeaderProgressTracker title={currentStepObj.title} hidden={currentStepObj.hidden} showContainer={currentStepObj.showContainer} hideProgressTracker={currentStepObj.hideProgressTracker} headerProductsText={true} stepName={currentStepObj.progressTitle} step={currentStepObj.categoryNumber} totalSteps={3} whiteBg={currentStepObj.whiteBackground} fullWidth={currentStepObj.fullWidth}>
                    <div className="Digital">
                        {currentStepObj.component}
                    </div>
                </HeaderProgressTracker>
            }
        </div>
    );
}

Digital.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Digital/Digital.js